<!-- 定义全局变量 -->
<script type="text/javascript">
// ******默认url链接********

//	var urlBase="http://192.168.1.28:7072/api";   //陈勇
 var urlBase="https://m-aqjjp.ahsjxjy.com/api";   //陈勇
// var urlBase="http://m.anhsjxjyxh.com/api";               //正式
// var urlBase="m-redis.ahsjxjy.com/api";
// var urlBase="http://weixin.ahsjxjy.com/api";          //微信测试
  //  var urlBase="http://m-redis.ahsjxjy.com/api";
// ******图片链接********
var imgBase="https://www.ahsjxjy.com";

export default
{
  urlBase,
  imgBase
}
</script>



// WEBPACK FOOTER //
// global.vue?6aad9b7f